import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';

export type FeatureStructure = {
  src: string;
  alt: string;
  text: string;
};

export const FEATURE_LIST: FeatureStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/1.svg/1.svg`,
    alt: 'Проектируем любые системы для дома',
    text:
      'Проектируем любые системы для дома: отопление, водоснабжение, электрику, вентиляцию и\u00a0фильтрацию воды.',
  },
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/3.svg/3.svg`,
    alt: 'Подготовим проект со всем необходимым',
    text:
      'Подготовим проект с\u00a0чертежами, расположением коммуникаций и\u00a0приборов, списком и\u00a0ценами стройматериалов.',
  },
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/2.svg/2.svg`,
    alt: 'Поможем с закупкой товаров и установкой',
    text: 'Поможем закупить товары и\u00a0установим систему любой сложности у\u00a0вас дома.',
  },
];
